import { Component } from '@angular/core';

@Component({
    selector: 'gbc-modal-section',
    templateUrl: './modal-section.component.html',
    styleUrls: ['./modal-section.component.scss'],
    standalone: true
})
export class ModalSectionComponent {
}
